// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._33FSfkB4aO2CfNubG6PQrF {\n    padding: 4px 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"boundary": "_33FSfkB4aO2CfNubG6PQrF"
};
module.exports = exports;
